import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import type { DirectionFindInterface } from '@zaoblako/shared/modules/catalog/dtos/direction/direction-find.dto';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';

import * as yup from 'yup';

/** Budget request item create/update request body */
export interface BudgetRequestItemFormInterface {
  /** Related direction */
  direction: DirectionFindInterface;
  /** Amount value */
  amount: number;
  /** Sub-items (for hierarchy mode) */
  children?: BudgetRequestItemFormInterface[];
}

/** Budget request item create/update request body - DTO schema */
export const BudgetRequestItemFormDto = SerdeDtoClass.create<BudgetRequestItemFormInterface>(TaskDtoKeysEnum.BUDGET_REQUEST_ITEM_FORM_DTO, {
  direction: {
    label: 'БС',
    checkers: [CatalogCheckersEnum.DIRECTION_ASSERT_EXISTS_BY_DTO],
    serializer: entityLikeSchema,
  },
  amount: {
    label: 'Сумма',
    serializer: yup
      .number()
      .min(0, DtoMessageEnum.NOT_ZERO_OR_POSITIVE),
  },
  children: {
    optional: true,
    label: 'Подстроки',
    nested: TaskDtoKeysEnum.BUDGET_REQUEST_ITEM_FORM_DTO,
    serializer: (_, nested) => yup.array(nested),
  },
});
